import Image from 'next/image'
import React from 'react'

import { API_URL } from '@goodfellas/environment'

import { goodfellasApi } from '../../../apis'
import { useFeedbackStore, useStore } from '../../../functions/store'
import checkmarkImage from '../../../public/images/icons/checked.png'

type FighterLabelProps = {
  key: string
  fighter: {
    fighterPhone: string
    fighterName: string
  }
  index: number
  isMobile?: boolean
}

export const FighterLabel = ({
  fighter,
  index,
  isMobile,
}: FighterLabelProps) => {
  const userStore = useStore((state) => state)
  const store = useFeedbackStore((state) => state)
  const storeIndex = store.index || 0
  const { indexSelect } = store.feedbackActions
  const isRated = store.ratings[index].isRated

  const mobileClassNames = 'rounded-e-none mx-auto'

  const ratings = store.ratings
  const payloadAdapter = (store) => {
    return {
      name: store.name,
      date: new Date().toISOString(),
      phoneNumber: store.phoneNumber,
      belt: store.belt,
      degree: store.degree,
      type: store.type,
      ratings: ratings.map((rating) => {
        return {
          fighterPhone: rating.fighterPhone,
          fighterName: rating.fighterName,
          fighterBelt: rating.fighterBelt,
          fighterBeltDegree: rating.fighterBeltDegree,
          fighterType: rating.fighterType,
          gameStyle: rating.gameStyle,
          pointsLeft: rating.pointsLeft,
          personalSkills: {
            agility: rating.personalSkills.agility,
            commitment: rating.personalSkills.commitment,
            focus: rating.personalSkills.focus,
            stamina: rating.personalSkills.stamina,
            strength: rating.personalSkills.strength,
            technique: rating.personalSkills.technique,
          },
          gameSkills: {
            guard: rating.gameSkills.guard,
            guardPassing: rating.gameSkills.guardPassing,
            guardRecovery: rating.gameSkills.guardRecovery,
            positionDefense: rating.gameSkills.positionDefense,
            submission: rating.gameSkills.submission,
            submissionDefense: rating.gameSkills.submissionDefense,
            sweep: rating.gameSkills.sweep,
            takedown: rating.gameSkills.takedown,
          },
        }
      }),
    }
  }

  const sendFeedback = async () => {
    const loader = document.getElementById('spinningLoader')
    loader?.classList.toggle('hidden')
    loader?.classList.toggle('flex')

    const payload = payloadAdapter(store)

    try {
      await goodfellasApi.post(`${API_URL}evaluation/feedback`, {
        ...payload,
        groupId: userStore?.group?._id,
      })

      loader?.classList.toggle('hidden')
      loader?.classList.toggle('flex')
    } catch (error) {
      console.error('Error sending feedback:', error)
    }
  }

  return (
    <li
      key={fighter.fighterPhone}
      className={`mb-2 px-3 rounded-full cursor-pointer ${
        !isMobile ? mobileClassNames : ''
      } ${index === storeIndex ? 'bg-red-400/80 text-white' : 'text-white/60'}`}
      onClick={() => {
        indexSelect(index)
        sendFeedback()
      }}
      id={index.toString()}
    >
      <div className="flex flex-row">
        <p className="max-h-6 overflow-hidden font-bold">
          {fighter.fighterName
            ? fighter.fighterName
            : `{${fighter.fighterPhone}}`}
        </p>
        {isRated ? (
          <Image
            className="self-start m-0 mt-1 ms-2"
            alt={fighter.fighterName}
            src={checkmarkImage}
            width={15}
          />
        ) : (
          ''
        )}
      </div>
    </li>
  )
}
